@if (state() === 'enabled') {
  <div class="prevention-banner prevention-banner--success">
    <div class="prevention-banner__text-and-button">
      <div class="prevention-banner__text">
        <div class="prevention-banner__title-row">
          <svg
            class="prevention-banner__shield-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6E32E0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 .5-.87l7-4a1 1 0 0 1 1 0l7 4A1 1 0 0 1 20 6z"
            />
            <path d="m9 12 2 2 4-4" />
          </svg>
          <span class="prevention-banner__title prevention-banner__title--success">Prevention activated</span>
        </div>
        <p class="prevention-banner__description">
          You're all set. A fix has been applied and the agent can no longer perform this action.<br />
          Future attempts will be blocked in real time.
        </p>
      </div>
      <a class="prevention-banner__link" [href]="blockedActionsLink">View blocked actions</a>
    </div>
    <div class="prevention-banner__illustration prevention-banner__illustration--success">
      <img src="assets/images/banners/banner-shield-image.svg" alt="" />
    </div>
  </div>
} @else {
  <div class="prevention-banner">
    <div class="prevention-banner__content">
      <h3 class="prevention-banner__title">Prevent this scenario from happening again</h3>
      @if (bannerType === 'review_boundary') {
        <p class="prevention-banner__description prevention-banner__description--with-button">
          Turn this instance into a learning opportunity and close the loop now. Applying a preventative boundary sets a
          permanent fix, ensuring similar patterns are blocked and never resurface.
        </p>
      }
      @if (bannerType === 'activate_prevention') {
        <p class="prevention-banner__description prevention-banner__description--with-button">
          Make this the last time. Close the loop now with a permanent fix so this scenario is automatically handled
          going forward.
        </p>
      }

      @if (bannerType === 'review_boundary') {
        <button type="button" class="prevention-banner__button" (click)="onButtonClick()">
          Review suggested boundary
        </button>
      }

      @if (bannerType === 'activate_prevention') {
        <button
          type="button"
          class="prevention-banner__button prevention-banner__button--activate"
          [disabled]="state() === 'enabling'"
          (click)="onButtonClick()"
        >
          @if (state() === 'enabling') {
            <mat-progress-spinner class="prevention-banner__spinner" color="primary" mode="indeterminate" diameter="16">
            </mat-progress-spinner>
            <span>Activating...</span>
          } @else {
            <span>Activate prevention</span>
          }
        </button>
      }
    </div>
    <div class="prevention-banner__illustration">
      <img src="assets/images/banners/banner-shield-image.svg" alt="" />
    </div>
  </div>
}
